export default __webpack_public_path__ + "static/media/courses-white.fc42fe4a.svg";